import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { readSelectedLocations } from '@/utils/bulkSelection';
import { BulkEditState, RootState } from '../types';
const namespaced: boolean = true;

export const state: BulkEditState = {
	menuRows: [],
	locationRows: [],
	count: 0,
	locationIds: readSelectedLocations()
};

export const BulkEdit: Module<BulkEditState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default BulkEdit;
